<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kundenbeziehung erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.suppliers.customer-relations.store', supplier))">
                <form-fields :form="form" :supplier="supplier" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplier',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    customer_number: null,
                    internal_customer_number: null,
                    notes: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>